<ion-grid class="prover-datepicker" [ngClass]="{'disabled': disabled}">
  <ion-row class="ion-align-content-center" id="{{id}}">
    <ion-col class="ion-align-self-center">
      <ion-label position="stacked">
        <h3 *ngIf="!isJohrei">
          {{labelName | translate}} <ion-text *ngIf="required" color="danger">*</ion-text>
        </h3>

        <p [ngStyle]="isColor">
          {{ dateTime ? (dateTime | dateFormat:'ddmmyyyy') : ('Não informado' | translate ) }}
        </p>
      </ion-label>
    </ion-col>

    <ion-col size="2" class="ion-align-self-center icon-calendar">
      <i class="fa-thin fa-calendar"></i>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-modal
  *ngIf="!disabled"
  trigger="{{id}}"
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  handleBehavior="cycle"
>
  <ng-template>
    <ion-header class="extendido">
      <ion-toolbar>
        <ion-title>{{labelName | translate}}</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-datetime
      presentation="date"
      [(ngModel)]="dateTime"
      [ngModelOptions]="{standalone: true}"
      doneText="{{ 'Confirmar' | translate}}"
      cancelText="{{ 'Cancelar' | translate}}"
      [showDefaultButtons]="true"
      (ionChange)="changeDate($event)"
      [locale]="idioma"
      [max]="maxDate"
      [min]="minDate"
      [disabled]="disabled"
    ></ion-datetime>
  </ng-template>
</ion-modal>
